import React, { useEffect, useState } from "react";
import api from "../lib/api";
import { toast } from "sonner";
import { Trash2, Mail, Phone, User, Calendar } from "lucide-react";

const Submissions = ({ resource, title, subtitle, type }) => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = async () => {
    setLoading(true);
    try {
      const { data } = await api.get(`/admin/submissions/${resource}`);
      setItems(data || []);
    } catch { toast.error("Erreur de chargement"); }
    finally { setLoading(false); }
  };

  useEffect(() => { load(); /* eslint-disable-next-line */ }, [resource]);

  const del = async (id) => {
    if (!window.confirm("Supprimer ce message ?")) return;
    try {
      await api.delete(`/admin/submissions/${resource}/${id}`);
      toast.success("Supprimé");
      load();
    } catch { toast.error("Erreur"); }
  };

  return (
    <div>
      <h1 className="font-serif-display text-2xl sm:text-3xl text-stone-800">{title}</h1>
      <p className="text-stone-500 mt-1 text-sm sm:text-base">{subtitle}</p>
      {loading ? (
        <div className="text-stone-500 p-8 text-center">Chargement...</div>
      ) : items.length === 0 ? (
        <div className="bg-white rounded-2xl p-12 text-center text-stone-500 mt-6">Aucune soumission pour le moment.</div>
      ) : (
        <div className="space-y-3 mt-6">
          {items.map((it) => (
            <div key={it.id} className="bg-white rounded-2xl shadow-sm p-5">
              <div className="flex items-start justify-between gap-4">
                <div className="flex-1">
                  <div className="flex flex-wrap items-center gap-x-5 gap-y-1 text-sm">
                    <span className="font-serif-display text-stone-800 text-lg">
                      <User size={14} className="inline mr-1" /> {type === "inscription" ? it.parentName : it.name}
                    </span>
                    <span className="text-stone-500"><Mail size={14} className="inline mr-1"/> {it.email}</span>
                    {it.phone && <span className="text-stone-500"><Phone size={14} className="inline mr-1"/> {it.phone}</span>}
                    <span className="text-stone-400"><Calendar size={14} className="inline mr-1"/> {new Date(it.createdAt).toLocaleString("fr-FR")}</span>
                  </div>
                  {type === "inscription" ? (
                    <div className="mt-3 text-stone-700">
                      <div><span className="text-stone-500 text-xs uppercase tracking-widest">Élève : </span>{it.childName || "—"} {it.age && <span className="text-stone-400">({it.age})</span>}</div>
                      <div><span className="text-stone-500 text-xs uppercase tracking-widest">Cours souhaité : </span>{it.course}</div>
                      {it.message && <div className="mt-2 text-stone-600 bg-stone-50 p-3 rounded-lg text-sm">{it.message}</div>}
                    </div>
                  ) : (
                    <div className="mt-3 text-stone-700 bg-stone-50 p-3 rounded-lg text-sm whitespace-pre-wrap">{it.message}</div>
                  )}
                </div>
                <button onClick={() => del(it.id)} className="p-2 rounded-lg bg-red-50 hover:bg-red-100 text-red-600"><Trash2 size={16}/></button>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export const InscriptionsAdmin = () => (
  <Submissions resource="inscriptions" title="Inscriptions reçues" subtitle="Demandes de pré-inscription via le formulaire public." type="inscription" />
);

export const ContactsAdmin = () => (
  <Submissions resource="contacts" title="Messages reçus" subtitle="Messages envoyés via le formulaire de contact." type="contact" />
);
